<template>
  <section>
    <p v-scroll-reveal>
      {{ data_clientInfo[this.lang] }}
    </p>
    <ul>
      <li v-scroll-reveal="{ origin: 'top', delay: 100 }">
        <img alt="Google" src="@/assets/img/g-logo-original.png" />
      </li>
      <li v-scroll-reveal="{ origin: 'top', delay: 200 }">
        <img alt="Extra Petite" src="@/assets/img/ep-logo-original.png" />
      </li>
      <li v-scroll-reveal="{ origin: 'top', delay: 300 }">
        <img class="no-padding" alt="Oh Si" src="@/assets/img/OS-logo-original.png" />
      </li>
    </ul>
    <div>
      <transition name="slide-fade" mode="out-in" tag="div">
        <div v-scroll-reveal="{ origin: 'left', delay: 400 }" id="testimonials" class="testimonials" :key="comp_activeTestimonial.author">
          <p class="quote">
            "{{ comp_activeTestimonial.quote }}"
          </p>
          <p class="author">
            - {{ comp_activeTestimonial.author }}
          </p>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Clients',
  props: {
    lang: { type: String, default: 'EN' }
  },
  data() {
    return {
      data_clientInfo: {
        EN: 'Our clients range from Fortune 500 companies to individuals with growing brands, including:',
        ES: 'Nuestros clientes van desde empresas de la lista Fortune 500 hasta individuos con marcas en crecimiento, incluyendo:'
      },
      data_testimonials: {
        EN: [
          {
            quote: 'Lorna reimagined the onboarding experience for our global community of creators. She empowered us to rethink our approach to designing for users first by bringing together creativity and unique customer insights.',
            author: 'Karen Ng, Team Lead, Google Maps'
          },
          {
            quote: 'I came to Lorna for her broad range of expertise in the eComm space, but what’s even more impressive is her ability to find the right resources for and solve problems in areas outside of her primary knowledge base. Not to mention, her email organization skills are unparalleled, which makes any project with her feel effortless!',
            author: 'Jean Wang, Founder, Extra Petite'
          },
          {
            quote: 'Working with Lorna made me realize the power of having a mentor like her. Beyond her rich technology and market knowledge, she really takes the time to understand your brand and core values. She asks all the right questions and keeps me at the top of my game!',
            author: 'Denise Genit, Co-Founder & CEO, Oh! Sí'
          }
        ],
        ES: [
          {
            quote: 'Lorna reimaginó la experiencia de integración (onboarding) para nuestra comunidad global de creadores. Nos permitió repensar nuestro enfoque de diseño para los usuarios en primer lugar uniendo la creatividad y las ideas únicas de los clientes.',
            author: 'Karen Ng, Líder de equipo, Google Maps'
          },
          {
            quote: 'Vine a Lorna por su amplia experiencia en el espacio de Comercio Electrónico, pero lo que es aún más impresionante es su capacidad para encontrar los recursos adecuados y resolver problemas en áreas fuera de su base conocimiento primario. Sin mencionar que sus habilidades de organización de correo electrónico no tienen paralelo, lo que hace que cualquier proyecto con ella se sienta sin esfuerzo!',
            author: 'Jean Wang, Fundador, Extra Petite'
          },
          {
            quote: 'Trabajar con Lorna me hizo darme cuenta del poder de tener un mentor como ella. Más allá de su vasto conocimiento de tecnología y del mercado, ella realmente se toma el tiempo para entender tu marca y tus valores fundamentales. ¡Ella hace todas las preguntas correctas y me mantiene en la cima de mi juego!',
            author: 'Denise Genit, Cofundadora y CEO, Oh! Sí'
          }
        ]
      }
    }
  },
  computed: {
    comp_activeTestimonial() {
      return this.data_testimonials[this.lang][0];
    }
  },
  mounted() {
    this.$sr.reveal('#testimonials', {
      afterReveal: () => this.func_rotate()
    });
  },
  methods: {
    func_rotate() {
      const langs = Object.keys(this.data_testimonials);
      setInterval(() => {
        langs.forEach(lang => {
          let testimonial = this.data_testimonials[lang].shift();
          this.data_testimonials[lang].push(testimonial);
        });
      }, 10000);
    }
  }
}
</script>

<style scoped>
  section {
    max-width: 900px;
  }

  p {
    align-self: center;
    max-width: 800px;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    align-self: center;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .testimonials {
    font-style: italic;
    align-self: start;
    min-height: 300px;
  }

  .author {
    margin-top: 30px;
    color: var(--secondary-color);
  }

  .quote, .author {
    max-width: 900px;
  }

  .slide-fade-enter-active {
    transition: all .6s ease-in;
  }
  .slide-fade-leave-active {
    transition: all .9s ease-in-out;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
  }

  img {
    padding: 40px 20px;
    margin-left: auto;
    margin-right: auto;
    width: 85%;
  }

  .no-padding {
    padding: 10px;
    width: 55%;
  }

  @media (max-width: 654px) {
    img {
      width: 65%;
      padding: 30px 10px;
      height: auto;
    }

    .no-padding {
      width: 50%;
    }
  }
</style>
